import type { InputHTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

import { generateDataTestId } from '@/lib/tests';
import type { WithHTMLProp } from '@/lib/types';

import * as S from './Radio.styles';

export type InputColorVariant = 'inherit' | 'white';

export interface RadioProps
  extends InputHTMLAttributes<HTMLInputElement>,
    WithHTMLProp<'className'> {
  children?: ReactNode;
  colorVariant?: InputColorVariant;
  label?: ReactNode;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      checked,
      children,
      className,
      colorVariant = 'inherit',
      disabled = false,
      label,
      onChange,
      ...props
    },
    ref,
  ) => {
    return (
      <S.Wrapper
        className={className}
        data-test-id='RadioWrapper'
        disabled={disabled}
      >
        <S.InputCheckbox
          {...generateDataTestId('radio', props.name || props.id || '')}
          ref={ref}
          checked={checked}
          colorVariant={colorVariant}
          data-test-id='RadioInputCheckbox'
          disabled={disabled}
          onChange={onChange}
          type='radio'
          {...props}
        />
        {label}
        {children}
      </S.Wrapper>
    );
  },
);

Radio.displayName = 'Radio';
